<template>
  <Fragment>
    <div class="form-group form-row">
      <StepFieldLabel column-classes="col-3 col-sm-4"> </StepFieldLabel>
      <StepInputGroup column-classes="col-4 col-md-3 col-lg-2">
        <label
          class="text-white font-main font-weight-bold text-center col-heading"
        >
          Tractor
        </label>
      </StepInputGroup>
      <StepInputGroup column-classes="col-4 col-md-3 col-lg-2">
        <label
          class="text-white font-main font-weight-bold text-center col-heading"
        >
          Trailer
        </label>
      </StepInputGroup>
    </div>
    <div class="form-group form-row">
      <StepFieldLabel column-classes="col-3 col-sm-4">
        Total Units
      </StepFieldLabel>
      <StepInputGroup column-classes="col-4 col-md-3 col-lg-2">
        <Money
          v-model="form.tractor.total"
          v-bind="masks.number"
          class="form-control form-control-lg"
          type="text"
          required
          @input="onFieldChange($event, fleetDetails.tractor.total)"
        />
      </StepInputGroup>
      <StepInputGroup column-classes="col-4 col-md-3 col-lg-2">
        <Money
          v-model="form.trailer.total"
          v-bind="masks.number"
          class="form-control form-control-lg"
          type="text"
          required
          @input="onFieldChange($event, fleetDetails.trailer.total)"
        />
      </StepInputGroup>
    </div>

    <div class="form-group form-row">
      <StepFieldLabel column-classes="col-3 col-sm-4">
        Annual Distance<br /><span>miles</span>
      </StepFieldLabel>
      <StepInputGroup column-classes="col-4 col-md-3 col-lg-2">
        <Money
          v-model="form.tractor.annualDistance"
          v-bind="masks.number"
          class="form-control form-control-lg"
          type="text"
          required
          @input="onFieldChange($event, fleetDetails.tractor.annualDistance)"
        />
      </StepInputGroup>
      <StepInputGroup column-classes="col-4 col-md-3 col-lg-2">
        <Money
          v-model="form.trailer.annualDistance"
          v-bind="masks.number"
          class="form-control form-control-lg"
          type="text"
          required
          @input="onFieldChange($event, fleetDetails.trailer.annualDistance)"
        />
      </StepInputGroup>
    </div>
  </Fragment>
</template>

<script>
import { Money } from 'v-money';
import { Fragment } from 'vue-frag';

import StepFieldLabel from '../step-elements/StepFieldLabel.vue';
import StepInputGroup from '../step-elements/StepInputGroup.vue';
import { mapState, mutation, masks } from '../store';
import { defaultFleetDetails } from '../store/state';

export default {
  name: 'FleetDetails',

  components: { Money, Fragment, StepInputGroup, StepFieldLabel },

  data() {
    return {
      /** @type {FleetDetails} */
      form: defaultFleetDetails(),
      masks,
    };
  },

  computed: {
    ...mapState({
      /** @returns {FleetDetails} */
      fleetDetails: (/** @type {ROICalculatorState} */ state) => {
        return state.formValues.fleetDetails;
      },
    }),
  },

  watch: {
    fleetDetails: {
      handler: function (newVal, oldVal) {
        if (newVal === oldVal) {
          return;
        }

        this.form = JSON.parse(JSON.stringify(newVal));
      },
      immediate: true,
    },
  },

  methods: {
    onFieldChange(formValue, stateValue) {
      if (stateValue == formValue) {
        return;
      }

      this.$store.commit(mutation('SET_FLEET_DETAILS_VALUES'), this.form);
    },
  },
};

/**
 * @typedef {import('../store/state').ROICalculatorState} ROICalculatorState
 * @typedef {import('../store/state').FleetDetails} FleetDetails
 */
</script>
